// extracted by mini-css-extract-plugin
export default {"headerArrows":"tQRQfLRC","arrow":"YhAT3gAU","_inactive":"NljghYrX"};